import { authStore } from '@/lib/auth/auth';
import { isReadOnlyMarketAccess, isWritableMarketAccess } from '@/features/market/marketAccess';
import { useMarketLocationSync } from '@/features/market/useMarketLocationSync';
import { showReadOnlyMarketToast } from '@/lib/useToastStore';
import * as React from 'react';

export function useWritableMarketPreflight() {
  const marketAccess = authStore((state) => state.session?.me.profile.market_access ?? null);
  const syncMarketLocation = useMarketLocationSync();

  return React.useCallback(async () => {
    // Fast path: already confirmed writable, skip the network round-trip.
    if (isWritableMarketAccess(marketAccess)) {
      return true;
    }

    // For read_only or unknown state, sync location first — the user may have
    // moved into a supported market since the last refresh.
    const me = await syncMarketLocation();
    const nextMarketAccess = me?.profile.market_access ?? authStore.getState().session?.me.profile.market_access ?? null;

    if (isReadOnlyMarketAccess(nextMarketAccess)) {
      showReadOnlyMarketToast();
      return false;
    }

    return isWritableMarketAccess(nextMarketAccess);
  }, [marketAccess, syncMarketLocation]);
}
